/**
 * Slim ABI of P2PEscrow.sol — only the functions/events/errors the backend uses.
 * Source: contracts/p2p/out/P2PEscrow.sol/P2PEscrow.json (regenerated with `forge build`).
 *
 * Same code deploys on Uni2chain (token=w2usdt) and BSC (token=USDT BEP20).
 */
export const P2P_ESCROW_ABI = [
  // ===== writes (maker) =====
  {
    type: 'function',
    name: 'createOrder',
    inputs: [
      { name: 'side', type: 'uint8' },
      { name: 'amount', type: 'uint256' },
      { name: 'premiumBps', type: 'int16' },
      { name: 'expiresAt', type: 'uint64' },
      { name: 'fillMode', type: 'uint8' },
    ],
    outputs: [{ name: 'orderId', type: 'bytes32' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'takeOrder',
    inputs: [
      { name: 'side', type: 'uint8' },
      { name: 'amount', type: 'uint256' },
      { name: 'premiumBps', type: 'int16' },
      { name: 'fillMode', type: 'uint8' },
      { name: 'targetMakerOrderId', type: 'bytes32' },
    ],
    outputs: [{ name: 'orderId', type: 'bytes32' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'cancelOrder',
    inputs: [{ name: 'orderId', type: 'bytes32' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'expireOrder',
    inputs: [{ name: 'orderId', type: 'bytes32' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },

  // ===== writes (relayer) =====
  {
    type: 'function',
    name: 'executeTrades',
    inputs: [
      {
        name: 'legs',
        type: 'tuple[]',
        components: [
          { name: 'orderId', type: 'bytes32' },
          { name: 'recipient', type: 'address' },
          { name: 'amount', type: 'uint256' },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },

  // ===== writes (owner) =====
  { type: 'function', name: 'setMinOrderAmount', inputs: [{ name: 'v', type: 'uint256' }], outputs: [], stateMutability: 'nonpayable' },
  { type: 'function', name: 'setMaxPremiumBps', inputs: [{ name: 'v', type: 'uint16' }], outputs: [], stateMutability: 'nonpayable' },
  { type: 'function', name: 'setMaxExpirationSeconds', inputs: [{ name: 'v', type: 'uint64' }], outputs: [], stateMutability: 'nonpayable' },
  { type: 'function', name: 'setPlatformFeeBps', inputs: [{ name: 'v', type: 'uint16' }], outputs: [], stateMutability: 'nonpayable' },
  { type: 'function', name: 'setGasFeeFlat', inputs: [{ name: 'v', type: 'uint256' }], outputs: [], stateMutability: 'nonpayable' },
  { type: 'function', name: 'setTakeMaxTtlSeconds', inputs: [{ name: 'v', type: 'uint64' }], outputs: [], stateMutability: 'nonpayable' },
  { type: 'function', name: 'withdrawFees', inputs: [{ name: 'amount', type: 'uint256' }], outputs: [], stateMutability: 'nonpayable' },
  { type: 'function', name: 'setMaxVolumePer24h', inputs: [{ name: 'v', type: 'uint256' }], outputs: [], stateMutability: 'nonpayable' },
  { type: 'function', name: 'setRelayer', inputs: [{ name: 'newRelayer', type: 'address' }], outputs: [], stateMutability: 'nonpayable' },
  { type: 'function', name: 'setTreasury', inputs: [{ name: 'newTreasury', type: 'address' }], outputs: [], stateMutability: 'nonpayable' },
  { type: 'function', name: 'acceptTreasuryRole', inputs: [], outputs: [], stateMutability: 'nonpayable' },
  { type: 'function', name: 'resetVolumeWindow', inputs: [], outputs: [], stateMutability: 'nonpayable' },
  { type: 'function', name: 'pause', inputs: [], outputs: [], stateMutability: 'nonpayable' },
  { type: 'function', name: 'unpause', inputs: [], outputs: [], stateMutability: 'nonpayable' },
  { type: 'function', name: 'emergencyRefund', inputs: [{ name: 'orderId', type: 'bytes32' }], outputs: [], stateMutability: 'nonpayable' },
  {
    type: 'function',
    name: 'emergencyWithdrawTo',
    inputs: [
      { name: 'orderId', type: 'bytes32' },
      { name: 'alternateRecipient', type: 'address' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },

  // ===== reads =====
  {
    type: 'function',
    name: 'getOrder',
    inputs: [{ name: 'orderId', type: 'bytes32' }],
    outputs: [
      {
        name: '',
        type: 'tuple',
        components: [
          { name: 'maker', type: 'address' },
          { name: 'side', type: 'uint8' },
          { name: 'fillMode', type: 'uint8' },
          { name: 'status', type: 'uint8' },
          { name: 'premiumBps', type: 'int16' },
          { name: 'expiresAt', type: 'uint48' },
          { name: 'isTake', type: 'bool' },
          { name: 'amount', type: 'uint256' },
          { name: 'expectedAmount', type: 'uint256' },
          { name: 'filled', type: 'uint256' },
          { name: 'targetMakerOrderId', type: 'bytes32' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  { type: 'function', name: 'getRemaining', inputs: [{ name: 'orderId', type: 'bytes32' }], outputs: [{ name: '', type: 'uint256' }], stateMutability: 'view' },
  { type: 'function', name: 'availableWindowCapacity', inputs: [], outputs: [{ name: '', type: 'uint256' }], stateMutability: 'view' },
  { type: 'function', name: 'minOrderAmount', inputs: [], outputs: [{ name: '', type: 'uint256' }], stateMutability: 'view' },
  { type: 'function', name: 'maxPremiumBps', inputs: [], outputs: [{ name: '', type: 'uint16' }], stateMutability: 'view' },
  { type: 'function', name: 'maxExpirationSeconds', inputs: [], outputs: [{ name: '', type: 'uint64' }], stateMutability: 'view' },
  { type: 'function', name: 'platformFeeBps', inputs: [], outputs: [{ name: '', type: 'uint16' }], stateMutability: 'view' },
  { type: 'function', name: 'gasFeeFlat', inputs: [], outputs: [{ name: '', type: 'uint256' }], stateMutability: 'view' },
  { type: 'function', name: 'takeMaxTtlSeconds', inputs: [], outputs: [{ name: '', type: 'uint64' }], stateMutability: 'view' },
  { type: 'function', name: 'feesAccrued', inputs: [], outputs: [{ name: '', type: 'uint256' }], stateMutability: 'view' },
  { type: 'function', name: 'maxVolumePer24h', inputs: [], outputs: [{ name: '', type: 'uint256' }], stateMutability: 'view' },
  { type: 'function', name: 'currentWindowVolume', inputs: [], outputs: [{ name: '', type: 'uint256' }], stateMutability: 'view' },
  { type: 'function', name: 'currentWindowStart', inputs: [], outputs: [{ name: '', type: 'uint64' }], stateMutability: 'view' },
  { type: 'function', name: 'relayer', inputs: [], outputs: [{ name: '', type: 'address' }], stateMutability: 'view' },
  { type: 'function', name: 'treasury', inputs: [], outputs: [{ name: '', type: 'address' }], stateMutability: 'view' },
  { type: 'function', name: 'token', inputs: [], outputs: [{ name: '', type: 'address' }], stateMutability: 'view' },
  { type: 'function', name: 'paused', inputs: [], outputs: [{ name: '', type: 'bool' }], stateMutability: 'view' },

  // ===== events =====
  {
    type: 'event',
    name: 'OrderCreated',
    inputs: [
      { name: 'orderId', type: 'bytes32', indexed: true },
      { name: 'maker', type: 'address', indexed: true },
      { name: 'side', type: 'uint8', indexed: false },
      { name: 'amount', type: 'uint256', indexed: false },
      { name: 'expectedAmount', type: 'uint256', indexed: false },
      { name: 'premiumBps', type: 'int16', indexed: false },
      { name: 'fillMode', type: 'uint8', indexed: false },
      { name: 'expiresAt', type: 'uint48', indexed: false },
      { name: 'isTake', type: 'bool', indexed: false },
      { name: 'targetMakerOrderId', type: 'bytes32', indexed: true },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'OrderFilled',
    inputs: [
      { name: 'orderId', type: 'bytes32', indexed: true },
      { name: 'recipient', type: 'address', indexed: true },
      { name: 'amount', type: 'uint256', indexed: false },
      { name: 'filledTotal', type: 'uint256', indexed: false },
      { name: 'percentFee', type: 'uint256', indexed: false },
      { name: 'flatFee', type: 'uint256', indexed: false },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'OrderClosed',
    inputs: [
      { name: 'orderId', type: 'bytes32', indexed: true },
      { name: 'status', type: 'uint8', indexed: false },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'EmergencyRefunded',
    inputs: [
      { name: 'orderId', type: 'bytes32', indexed: true },
      { name: 'recipient', type: 'address', indexed: true },
      { name: 'amount', type: 'uint256', indexed: false },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'AdminConfigUpdated',
    inputs: [
      { name: 'param', type: 'string', indexed: false },
      { name: 'newValue', type: 'uint256', indexed: false },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'RelayerUpdated',
    inputs: [
      { name: 'oldRelayer', type: 'address', indexed: true },
      { name: 'newRelayer', type: 'address', indexed: true },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'GasFeeFlatUpdated',
    inputs: [
      { name: 'oldValue', type: 'uint256', indexed: false },
      { name: 'newValue', type: 'uint256', indexed: false },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'FeesWithdrawn',
    inputs: [
      { name: 'to', type: 'address', indexed: true },
      { name: 'amount', type: 'uint256', indexed: false },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'TreasuryUpdated',
    inputs: [
      { name: 'oldTreasury', type: 'address', indexed: true },
      { name: 'newTreasury', type: 'address', indexed: true },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'RateLimitWindowReset',
    inputs: [{ name: 'windowStart', type: 'uint64', indexed: false }],
    anonymous: false,
  },
  { type: 'event', name: 'Paused', inputs: [{ name: 'account', type: 'address', indexed: false }], anonymous: false },
  { type: 'event', name: 'Unpaused', inputs: [{ name: 'account', type: 'address', indexed: false }], anonymous: false },

  // ===== custom errors (ethers will decode reverts to readable names) =====
  { type: 'error', name: 'NotRelayer', inputs: [] },
  { type: 'error', name: 'InvalidAddress', inputs: [] },
  { type: 'error', name: 'AmountTooSmall', inputs: [{ name: 'amount', type: 'uint256' }, { name: 'min', type: 'uint256' }] },
  { type: 'error', name: 'PremiumOutOfRange', inputs: [{ name: 'premium', type: 'int16' }, { name: 'maxAbs', type: 'uint16' }] },
  { type: 'error', name: 'InvalidExpiration', inputs: [] },
  { type: 'error', name: 'ExpirationOverflow', inputs: [] },
  { type: 'error', name: 'OrderNotFound', inputs: [] },
  { type: 'error', name: 'NotOrderMaker', inputs: [] },
  { type: 'error', name: 'InvalidStatus', inputs: [{ name: 'current', type: 'uint8' }] },
  { type: 'error', name: 'AlreadyExpired', inputs: [] },
  { type: 'error', name: 'NotExpired', inputs: [] },
  { type: 'error', name: 'FillOverflow', inputs: [{ name: 'filledAfter', type: 'uint256' }, { name: 'amount', type: 'uint256' }] },
  { type: 'error', name: 'RateLimitExceeded', inputs: [{ name: 'attempted', type: 'uint256' }, { name: 'cap', type: 'uint256' }, { name: 'used', type: 'uint256' }] },
  { type: 'error', name: 'EmptyBatch', inputs: [] },
  { type: 'error', name: 'FeeBpsTooHigh', inputs: [{ name: 'bps', type: 'uint16' }] },
  { type: 'error', name: 'MaxPremiumTooHigh', inputs: [{ name: 'bps', type: 'uint16' }] },
  { type: 'error', name: 'MaxExpirationTooLong', inputs: [{ name: 'seconds_', type: 'uint64' }] },
  { type: 'error', name: 'NotPendingTreasury', inputs: [] },
  { type: 'error', name: 'EnforcedPause', inputs: [] },
  { type: 'error', name: 'ExpectedPause', inputs: [] },
  { type: 'error', name: 'GasFeeFlatTooHigh', inputs: [{ name: 'v', type: 'uint256' }] },
  { type: 'error', name: 'TakeMaxTtlInvalid', inputs: [{ name: 'v', type: 'uint64' }] },
  { type: 'error', name: 'InvalidTakeTarget', inputs: [] },
  { type: 'error', name: 'FeeExceedsFill', inputs: [{ name: 'fill', type: 'uint256' }, { name: 'totalFee', type: 'uint256' }] },
  { type: 'error', name: 'MaxVolumePer24hZero', inputs: [] },
  { type: 'error', name: 'InsufficientFees', inputs: [{ name: 'requested', type: 'uint256' }, { name: 'available', type: 'uint256' }] },
  { type: 'error', name: 'MinOrderAmountZero', inputs: [] },
  { type: 'error', name: 'FeeConfigInconsistent', inputs: [{ name: 'minOrder', type: 'uint256' }, { name: 'gasFee', type: 'uint256' }, { name: 'feeBps', type: 'uint16' }] },
] as const;

/** Enum mirrors of P2PEscrow.sol — keep in sync with contract. */
export enum P2PSideEnum {
  SELL_W2USDT = 0,
  SELL_USDT = 1,
}

export enum P2PFillModeEnum {
  PARTIAL_OK = 0,
  AON = 1,
}

export enum P2PStatusEnum {
  ACTIVE = 0,
  PARTIAL = 1,
  FILLED = 2,
  CANCELLED = 3,
  EXPIRED = 4,
}

export type P2PChainName = 'UNI2' | 'BSC';

/**
 * Minimal ERC20 ABI for approve + allowance + balanceOf — used to gate
 * createOrder behind a token approval to the escrow.
 */
export const ERC20_MIN_ABI = [
  {
    type: 'function',
    name: 'approve',
    inputs: [
      { name: 'spender', type: 'address' },
      { name: 'amount', type: 'uint256' },
    ],
    outputs: [{ name: '', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'allowance',
    inputs: [
      { name: 'owner', type: 'address' },
      { name: 'spender', type: 'address' },
    ],
    outputs: [{ name: '', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'balanceOf',
    inputs: [{ name: 'account', type: 'address' }],
    outputs: [{ name: '', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'decimals',
    inputs: [],
    outputs: [{ name: '', type: 'uint8' }],
    stateMutability: 'view',
  },
] as const;
